import { useEffect, useState } from 'react';

import { getPreferredLocale } from '@/services/locale.service';

export default function usePreferredLocale() {
  const [locale, setLocale] = useState(() => getPreferredLocale());

  useEffect(() => {
    const handleLocaleChange = (event) => {
      setLocale(event?.detail?.locale || getPreferredLocale());
    };

    window.addEventListener('suarte:preferred-language-changed', handleLocaleChange);
    return () => {
      window.removeEventListener('suarte:preferred-language-changed', handleLocaleChange);
    };
  }, []);

  return locale;
}
